import { useMutation, useQueryClient } from '@tanstack/react-query';
import api from '../../http';
import { useForBindingId } from '../../../forBinding';
import { getApiErrorMessage, toApiError } from '../utils';
import type { FieldDiaryRequestOptions } from './types';

export const useDeleteFieldDiaryNote = ({
	forBinding: ownerForBinding,
}: FieldDiaryRequestOptions = {}) => {
	const queryClient = useQueryClient();
	const contextForBinding = useForBindingId();
	const forBinding = ownerForBinding ?? contextForBinding;

	return useMutation({
		mutationFn: async (id: string) => {
			try {
				await api.delete(`/field-diary/notes/delete/${id}`, { params: { forBinding } });
			} catch (error) {
				throw toApiError(error, 'Erro ao excluir nota do diário de campo');
			}
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ['fieldDiary'] });
		},
		onError: (error) =>
			console.error(
				'Erro ao excluir nota do diário de campo:',
				getApiErrorMessage(error, 'Erro ao excluir nota do diário de campo')
			),
	});
};
